import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const attachFirewallToStacklet = (
  id: number,
  firewall_uuid: string,
): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { action: 'firewall_attach', firewall_uuid },
  });
